export const messages = {
  en: {
    serviceImplManage: {
      queryCondition: 'Query Conditions',
      serviceImplInfo: 'Service Implementation Info',
      serviceImplId: 'Service ID',
      businessType: 'Business Type',
      businessName: 'Business Name',
      invokeType: 'Invoke Type',
      kafkaTopic: 'Kafka Topic',
      operation: 'Operation',
      addServiceImpl: 'Add Service Implementation',
      editServiceImpl: 'Edit Service Implementation',
      confirmDeleteServiceImpl: 'Confirm to delete this service implementation?',
      enterBusinessType: 'Please enter business type',
      enterBusinessName: 'Please enter business name',
      selectInvokeType: 'Please select invoke type',
      enterKafkaTopic: 'Please enter Kafka topic',
      microservicePost: 'Microservice POST',
      webservice: 'Webservice',
      httpPost: 'HTTP POST',
      requiredBusinessType: 'Required, please enter business type',
      requiredBusinessName: 'Required, please enter business name',
      requiredInvokeType: 'Required, please select invoke type',
      invokeUrl: 'Invoke URL',
      requiredInvokeUrl: 'Required, please enter invoke URL',
      optionalKafkaTopic: 'Optional, please enter Kafka topic',
      timeout: 'Timeout',
      requiredTimeout: 'Required, please enter timeout',
      retryCount: 'Retry Count',
      requiredRetryCount: 'Required, please enter retry count',
      description: 'Description',
      optionalDescription: 'Optional, please enter description',
      businessTypeLength: 'Business type length should be 2-50 characters',
      businessNameLength: 'Business name length should be 2-50 characters',
      invokeUrlLength: 'Invoke URL length should not exceed 200 characters',
      kafkaTopicLength: 'Kafka topic length should not exceed 50 characters',
      timeoutNumber: 'Timeout must be a number',
      retryCountNumber: 'Retry count must be a number',
      descriptionLength: 'Description length should not exceed 200 characters'
    }
  },
  zh: {
    serviceImplManage: {
      queryCondition: '查询条件',
      serviceImplInfo: '服务实现信息',
      serviceImplId: '服务实现ID',
      businessType: '业务类型',
      businessName: '业务名称',
      invokeType: '调用类型',
      kafkaTopic: 'Kafka主题',
      operation: '操作',
      addServiceImpl: '添加服务实现',
      editServiceImpl: '修改服务实现',
      confirmDeleteServiceImpl: '确定删除该服务实现吗？',
      enterBusinessType: '请输入业务类型',
      enterBusinessName: '请输入业务名称',
      selectInvokeType: '请选择调用方式',
      enterKafkaTopic: '请输入Kafka主题',
      microservicePost: '微服务POST方式',
      webservice: 'webservice方式',
      httpPost: 'http post方式',
      requiredBusinessType: '必填，请填写业务类型',
      requiredBusinessName: '必填，请填写业务名称',
      requiredInvokeType: '必填，请选择调用类型',
      invokeUrl: '调用地址',
      requiredInvokeUrl: '必填，请填写调用地址',
      optionalKafkaTopic: '选填，请填写kafka主题',
      timeout: '超时时间',
      requiredTimeout: '必填，请填写超时时间',
      retryCount: '重试次数',
      requiredRetryCount: '必填，请填写重试次数',
      description: '描述',
      optionalDescription: '选填，请填写描述',
      businessTypeLength: '业务类型必须在2至50字符之间',
      businessNameLength: '业务名称必须在2至50字符之间',
      invokeUrlLength: '调用地址超过200位',
      kafkaTopicLength: 'kafka主题不能超过50',
      timeoutNumber: '超时时间必须为数字',
      retryCountNumber: '重试次数必须为数字',
      descriptionLength: '备注内容不能超过200'
    }
  }
}